
import { formatDistanceToNow } from "date-fns";

export const getCellularNetworkType = (cellularRat?: string | number): string => {
  if (!cellularRat) return 'Unknown';
  
  const ratString = String(cellularRat).toLowerCase();
  
  // Simplified cellular network type mappings with user-friendly names
  const networkTypes: { [key: string]: string } = {
    // RAT codes for 2G networks
    '0': '2G',
    '1': '2G',
    // RAT codes for 3G networks (UMTS/UTRAN variants)
    '2': '3G',
    '3': '2G', // GSM w/EGPRS is still 2G with enhanced data
    '4': '3G',
    '5': '3G',
    '6': '3G',
    // RAT code for 4G networks
    '7': '4G',
    // String-based mappings for direct entries
    'gsm': '2G',
    'umts': '3G',
    'lte': '4G',
    '4g': '4G',
    '3g': '3G',
    '2g': '2G',
    '5g': '5G'
  };
  
  return networkTypes[ratString] || `RAT ${cellularRat}`;
};

export const getFormattedDate = (dateString?: string): string => {
  if (!dateString) return 'Unknown';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid date';
    
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Unknown';
  }
};
